import React from 'react';
import { Link } from 'react-router-dom';
import { caseStudies } from '../mockData';
import { ArrowRight, TrendingUp } from 'lucide-react';

const ClientSuccess = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 text-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-6">
              <TrendingUp className="w-4 h-4" />
              <span>Client Success Stories</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Delivering Measurable Results</h1>
            <p className="text-xl text-indigo-100">
              Explore how we've helped enterprises across industries achieve digital transformation success with measurable business outcomes.
            </p>
          </div>
        </div>
      </section>

      {/* Case Studies Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {caseStudies.map((caseStudy) => (
              <Link
                key={caseStudy.id}
                to={`/client-success/${caseStudy.id}`}
                className="group bg-white rounded-2xl overflow-hidden border-2 border-gray-200 hover:border-indigo-500 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
              >
                {/* Header */}
                <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-8">
                  <div className="text-sm font-semibold text-indigo-600 mb-2">{caseStudy.industry}</div>
                  <h3 className="text-2xl font-bold text-gray-900 group-hover:text-indigo-600 transition-colors duration-200">
                    {caseStudy.title}
                  </h3>
                </div>

                {/* Content */}
                <div className="p-8">
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-500 uppercase mb-2">Challenge</h4>
                    <p className="text-gray-700">{caseStudy.challenge}</p>
                  </div>

                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-500 uppercase mb-3">Key Results</h4>
                    <div className="space-y-2">
                      {caseStudy.results.slice(0, 3).map((result, idx) => (
                        <div key={idx} className="flex items-start space-x-2">
                          <div className="w-1.5 h-1.5 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                          <p className="text-sm text-gray-700 font-medium">{result}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Technologies */}
                  <div className="flex flex-wrap gap-2 mb-6">
                    {caseStudy.technologies.map((tech, idx) => (
                      <span
                        key={idx}
                        className="px-3 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-full"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  <div className="flex items-center text-indigo-600 font-medium group-hover:translate-x-2 transition-transform duration-200">
                    <span>Read full case study</span>
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ClientSuccess;